module.exports = __webpack_public_path__ + "img/background.daa6dd77.png";